import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import settings from '../../utils/settings';
import ReactModal from 'react-modal';

class SendingProgress extends Component {
    render() {
        return (
            <div className="feedback-sending">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;&nbsp;Sending ...
            </div>
        );
    }
}

class ScoreSlider extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        e.preventDefault();
        var value = parseFloat(e.currentTarget.value, 10);
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render() {
        return (
            <div>
                <label className='form-label-inline feedback-form-label'>Score:  </label>
                <label className='form-label-inline-value feedback-form-label'>{this.props.value.toFixed(2)}</label>
                <input type="range"
                    className="score-slider"
                    min={ -1.00 }
                    max={ 1.00 }
                    step={ 0.01 }
                    value={ this.props.value }
                    onChange={ this.onChange } />
                <div className="score-gradient">
                </div>
            </div>
        );        
    }
}

class SentenceFeedbackDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChangeScore = this.onChangeScore.bind(this);
        this.reset = this.reset.bind(this);

        this.state = {
            error: '',
            sending: false,
            modalOpen: false,
            sentence: '',
            location: '',
            assigned_sentiment: {},
            feedback_sentiment: {}
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_SentenceFeedbackDialog');
    }

    reset() {
        this.setState(
            { 
                error: '', 
                sending: false
            });
    };

    close() {
        this.setState({
            sending: false,
            modalOpen: false
        })
    };

    open(sentence) {
        this.reset();
        this.setState({
            modalOpen: true,
            sentence: sentence.text,
            location: sentence.position[0] + '-' + sentence.position[1],
            assigned_sentiment: Object.assign({}, {
                class: sentence.class,
                classConfidence: sentence.classConfidence || 0.0,
                score: sentence.score || 0.0
            }),
            feedback_sentiment: {
                class: sentence.class,
                classConfidence: sentence.classConfidence || 0.0,
                score: sentence.score || 0.0
            },
            sentiment_model: settings.getValue('sentimentModel', window._sentimentModel)
        })
    };

    handleSubmit() {
        this.setState({sending: true});

        urlHandler.submitSentenceFeedback(
            {
                comment: this.refs.comment.value,
                sentence: this.state.sentence,
                location: this.state.location,
                assigned_sentiment: JSON.stringify(this.state.assigned_sentiment),
                feedback_sentiment: JSON.stringify(this.state.feedback_sentiment),
                sentiment_model: this.state.sentiment_model,
                content: this.props.text,
                results: this.props.results
            }
        ).then((response) => {
            console.log(response.data);
            this.close();
        }).catch((err) => {
            console.log(err.response.data);
            this.setState({
                sending: false,
                error: err.response.data
            })
        });
    };

    onChangeScore(val) {
        let classVal = 'neutral';
        if (val >= -1.0 && val < -0.25) {
            classVal = 'negative';
        } else if (val <= 1.0 && val > 0.25) {
            classVal = 'positive';
        }
        this.setState({
            feedback_sentiment: {
                class: classVal,
                classConfidence: this.state.feedback_sentiment.classConfidence,
                score: val
            }
        })
    }

    render() {

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '600px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
           <div id="rm_SentenceFeedbackDialog">
                <ReactModal ref="feedbackId" 
                    isOpen={this.state.modalOpen}
                    contentLabel="Feedback Form"
                    onRequestClose={this.close} 
                    style={styles}
                    closeTimeoutMS={1000}>
                    <div className="feedback-dialog">
                        <div className="feedback-header">
                            Sentence Sentiment Feedback
                        </div>
                        <div className="feedback-description">
                            <span className='fa fa-comments-o feedback-icon'>&nbsp;</span>
                            Notice a problem with sentiment assignment? Please provide any sentiment modifications along with any other 
                            information so we can enhance our product.    
                        </div>
                        <div className="feedback-content">
                            <div className="feedback-form">
                                <div className='form-field-wrapper'>
                                    <span>
                                        <label className='form-label-inline feedback-form-label'>Sentence:  </label>
                                        <label className='form-label-inline-value feedback-form-label'>{this.state.sentence}</label>
                                    </span>
                                    <br/><br/>
                                    <span>
                                        <label className='form-label-inline feedback-form-label'>Document Location:  </label>
                                        <label className='form-label-inline-value feedback-form-label'>{this.state.location}</label>
                                    </span>
                                </div>
                                <table className="form-field-table">
                                    <tbody>
                                        <tr>
                                            <td className="form-field-wrapper form-field-left">
                                                <label className='form-label feedback-form-label'>Assigned Sentiment:</label>
                                                <div className="form-field-sentiment-wrapper">
                                                    <span>
                                                        <label className='form-label-inline feedback-form-label'>Class:  </label>
                                                        <label className='form-label-inline-value feedback-form-label'>{this.state.feedback_sentiment.class}</label>
                                                    </span>
                                                    <br/>
                                                    <span>
                                                        <label className='form-label-inline feedback-form-label'>Class Confidence:  </label>
                                                        <label className='form-label-inline-value feedback-form-label'>{this.state.feedback_sentiment.classConfidence}</label>
                                                    </span>
                                                    <span>
                                                        <ScoreSlider value={this.state.feedback_sentiment.score} onChange={this.onChangeScore}/>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="form-field-wrapper form-field-right">
                                                <label htmlFor='issueField' className='form-label feedback-form-label'>Comments:</label>
                                                <textarea className='form-field feedback-textarea feedback-form-field'
                                                        name='comment'
                                                        id='commentField'
                                                        ref='comment'
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br/>
                                <span className="feedback-error-msg">{this.state.error}</span>
                            </div>
                        </div>
                        <div className="feedback-footer">
                            {this.state.sending ? <SendingProgress /> : null}
                            <button type="button" className="feedback-default-button" onClick={this.handleSubmit}>Submit Feedback</button>
                            <button type="button" className="feedback-default-button" onClick={this.close}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

export default SentenceFeedbackDialog;


